import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './authConfig'

// Shared MSAL instance - used by both the app and API client
export const msalInstance = new PublicClientApplication(msalConfig)
